import React from "react";
import styles from "./NameAndDescription.module.sass";
import TextInput from "../../../components/TextInput";
import { InputController } from "../../../hooks/input-controller";
import collection from "../../../i11/Collection";
import { useUser } from "../../../context";

const NameAndDescription = ({ className, setReqBody, reqBody, createO }) => {
	const { locale } = useUser();
	const name = InputController("name", setReqBody);
	const description = InputController("description", setReqBody);

	return (
		<div className={styles.description}>
			<TextInput
				className={styles.field}
				label={collection[locale].title}
				name="name"
				type="text"
				value={reqBody.name}
				tooltip="Maximum 100 characters. No HTML or emoji allowed"
				required
				{...name}
			/>
			<TextInput
				label={collection[locale].description}
				name="description"
				type="text"
				textarea
				value={reqBody.description}
				tooltip="Maximum 100 characters. No HTML or emoji allowed"
				required
				{...description}
			/>
			<div className={styles.editor}>
				<button onClick={createO} type="button" className="button-small">
					{collection[locale].detailed_description}
				</button>
			</div>
		</div>
	);
};

export default NameAndDescription;
